<template>
  
  <v-container grid-list-xl fluid>
    
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-right">
        <v-text-field
          v-model="search"
          label="Search"
          style="max-width: 500px; display: inline-block;"
        >
        </v-text-field>
        <v-tooltip top>
          <v-btn slot="activator" small color="primary" style="min-width: 0px; font-size: 12px;" :disabled="search == null || search == ''"><v-icon>fas fa-search</v-icon></v-btn>
          <span>Search</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="users"
          :pagination.sync="pagination"
          :total-items="totalUsers"
          :loading="loading"
          :rows-per-page-items="[25,50,100]"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.first_name }}</td>
            <td>{{ props.item.last_name }}</td>
            <td>
              <v-select
                v-model="props.item.role"
                :disabled="props.item._id == user._id"
                :items="roles"
                @change="updateUserRole(props.item._id, $event)"
              ></v-select>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>

export default {
  name: 'AdminUsers',
  data () {
    return {
      loading: true,
      search: null,
      users: [],

      roles: [
        {
          'text': 'User',
          'value': 'user'
        },
        {
          'text': 'Stylist',
          'value': 'stylist'
        },
        {
          'text': 'Admin',
          'value': 'admin'
        }
      ],

      headers: [
        {
          text: 'Email',
          sortable: false,
          value: 'email'
        },
        {
          text: 'First Name',
          sortable: false,
          value: 'first_name'
        },
        {
          text: 'Last Name',
          sortable: false,
          value: 'last_name'
        },
        {
          text: 'Role',
          sortable: false
        }
      ],
      pagination: {},
      totalUsers: 0,
    }
  },
  mounted: function() {
    this.getDataFromApi();
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi();
      },
      deep: true
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
  },
  methods: {
    getDataFromApi: function() {
      this.loading = true
        
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      
      this.$http.get('users?limit=' + rowsPerPage + '&page=' + page) 
        .then(response => {
          this.totalUsers = response.data.items.total;
          this.users = response.data.data;
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error loading users');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateUserRole: function(id, role) {
      this.$http.patch('users/' + id, {role: role})
        .then(response => {
          this.$toast.fire('User Updated');
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was a problem updating the user');
        });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
